import { createSlice } from "@reduxjs/toolkit";

import {
  getInvoicingExpensesInsightsAction,
  getInvoicingRevenueInsightsAction,
} from "@/redux/insights/actions";
import { initialState } from "@/redux/insights/initialState";
import type { InsightsType } from "@/redux/insights/insightTypes";
import { insightsReducer } from "@/redux/insights/reducer";

export const insightsSlice = createSlice({
  name: "insights",
  initialState,
  reducers: insightsReducer,

  extraReducers: (builder) => {
    builder.addCase(
      getInvoicingExpensesInsightsAction.pending,
      (state: InsightsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getInvoicingExpensesInsightsAction.fulfilled,
      (state: InsightsType, { payload }) => {
        const { success, message, result, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          invoicingExpensesInsightsData: result,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      getInvoicingExpensesInsightsAction.rejected,
      (state: InsightsType, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getInvoicingRevenueInsightsAction.pending,
      (state: InsightsType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getInvoicingRevenueInsightsAction.fulfilled,
      (state: InsightsType, { payload }) => {
        const { success, message, result, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          invoicingRevenueInsightsData: result,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      getInvoicingRevenueInsightsAction.rejected,
      (state: InsightsType, { error }) => ({
        ...state,
        fetching: false,
        error: error?.message ?? null,
      })
    );
  },
});

export const {
  resetError: resetInsightsError,
  resetSuccess: resetInsightsSuccess,
  resetInsightsFetching,
  resetInvoicingExpensesInsightsData,
  resetInvoicingRevenueInsightsData,
} = insightsSlice.actions;
